export default "__VITE_ASSET__CEzIn8uF__"